import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';

const AddButton = ({ children, onClick, className, size, ...props }) => {
  const cn = useClassNames(
    () => [
      'flex',
      'items-center',
      'text-blue-500',
      'p-4',
      'w-full',
      'select-none',
      'focus:outline-none',
      'lg:border-r',
      'hover:text-blue-700',
      className,
    ],
    [className],
  );
  const divCn = useClassNames(() => [
    'flex-shrink-0',
    'rounded-full',
    'border',
    'border-dashed',
    'flex',
    'items-center',
    'justify-center',
    'border-blue-500',
    'bg-blue-100',
    size === '8' && 'w-8',
    size === '8' && 'h-8',
    size === '10' && 'w-10',
    size === '10' && 'h-10',
  ]);
  return (
    <button type="button" className={cn} onClick={onClick} {...props}>
      <div className={divCn}>+</div>
      <div className="ml-3">{children}</div>
    </button>
  );
};

AddButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['8', '10']),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

AddButton.defaultProps = {
  size: '10',
};

export default AddButton;
